import { render } from "./CommonRules.vue?vue&type=template&id=762b6638&scoped=true"
import script from "./CommonRules.vue?vue&type=script&lang=js"
export * from "./CommonRules.vue?vue&type=script&lang=js"

import "./CommonRules.vue?vue&type=style&index=0&id=762b6638&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762b6638"]])

export default __exports__